<router-outlet></router-outlet>
<ngx-spinner
  bdColor="rgba(0,0,0,0.57)"
  size="default" 
  type="ball-spin"
  [fullScreen]="true"
  ><p style="color: white">Loading...</p></ngx-spinner
>
